import { Component, inject, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgIf } from '@angular/common';
import { LocalStorageService } from '../../services/local-storage.service';
import { UserInfo } from '../../models/users.model';
import { Subscription } from 'rxjs';
import { HttpServiceService } from '../../services/http-service.service';
import { AgentChatService } from '../../agent-chat/agent-chat.service';
import { USER_PERMISSIONS } from '../../app.constants';

@Component({
  selector: 'app-header',
  imports: [RouterLink, NgbModule, NgIf],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent implements OnDestroy {
  fullScreenClass: boolean = false;
  toggleMode: 'dark' | 'light' | undefined;
  localData: string | null = '';
  userInfo? : UserInfo;
  canUseAgent: boolean = false;
  private localStorageService = inject(LocalStorageService);
  private logoutSubscription? : Subscription;
  readonly agentChat = inject(AgentChatService);

  constructor(private router: Router, private route: ActivatedRoute, private httpService : HttpServiceService) {
    this.route.queryParams.subscribe((params: any) => {
      if (params.theme === 'dark' || params.theme === 'light') {
        localStorage.setItem("data-theme-version", params.theme);
      }
    });
  }

  ngOnInit(){
    this.userInfo = this.localStorageService.getItem("userInfo") as UserInfo;
    this.canUseAgent = this.localStorageService.checkPermission(
      USER_PERMISSIONS.AGENT?.AGENT_QUERY ?? 'agent_query'
    );
  }

  ngDoCheck() {
    this.applyThemeMode();
  }

  applyThemeMode() {    // Theme mode dark - light
    this.localData = localStorage.getItem('data-theme-version');
    if (this.localData) {
      document.body.setAttribute('data-theme-version', this.localData);
    }
  }

  logout(){
    this.logoutSubscription =  this.httpService.userLogout().subscribe({
      next : (resp) => {
        this.localStorageService.clear();
        this.router.navigate(['/', 'login']);
      }
    })
  }

  chatboxActive() { // Chatbox manage
    document.getElementById("chatBox")?.classList.add("active");
  }

  eventSidebarActive() { // Event Sidebar manage
    const sidebar = document.getElementById("eventSidebar");
    if (sidebar?.classList.contains('active')) {
      sidebar.classList.remove('active');
    } else {
      sidebar?.classList.add('active');
    }
  }

  themeMode() {     // Theme mode dark - light
    const elementValue = document.body.getAttribute('data-theme-version');
    this.localData = localStorage.getItem('data-theme-version');

    this.toggleMode = (elementValue === 'light' && this.localData === 'light') ? 'dark' : 'light';

    localStorage.setItem("data-theme-version", this.toggleMode);
    document.body.setAttribute('data-theme-version', this.toggleMode);
  }

  ngOnDestroy(){
    this.logoutSubscription?.unsubscribe();
  }

  

}
